import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@markant-platform/shared/data-access';
import { CampaignOrganizationAndUserRegistrationDto, DemoUserRegistration } from '@markant-platform/registration/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private readonly registrationApiUrl = AppConfigService.appConfiguration.apiUrl['registration'];

  private readonly http = inject(HttpClient);

  registerDemoUser(payload: DemoUserRegistration): Observable<string> {
    return this.http.post<string>(this.registrationApiUrl + '/demo', payload);
  }

  registerCampaignCustomer(
    registrationRequest: CampaignOrganizationAndUserRegistrationDto,
    campaignId: string
  ): Observable<string> {
    return this.http.post<string>(`${this.registrationApiUrl}/campaign/${campaignId}`, registrationRequest);
  }
}
